// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"12":"94158fe16e29ce3a","94":"9a1fc5c5dc757694","631":"b345cd4269570768","713":"b869a2bfdd5a600a"}[chunkId] + ".js";
};